export enum EnvironmentType {
    Base = 'base',
    Develop = 'develop',
    Staging = 'staging',
    Treino = 'treino',
    Prod = 'prod'
    
}